<template>
  <mds-table>
    <mds-tbody>
      <mds-tr
        v-for="(link, index) in links"
        :key="link.id"
      >
        <mds-td
          v-for="header in $options.headers"
          :key="header.fieldName"
          :style="header.style"
        >
          <template v-if="header.fieldName === 'processStartTime' || header.fieldName === 'processEndTime'">
            <template v-if="link[header.fieldName]">
              {{ link[header.fieldName] | formatDate }}
            </template>
            <template v-else>
              {{ '—' }}
            </template>
          </template>
          <template v-else-if="header.fieldName === 'indexType'">
            {{ link[header.fieldName]}}  
          </template>
          <template v-else-if="header.fieldName === 'frequency'">
            {{ link[header.fieldName]?link[header.fieldName]:'—' }}
          </template>
          <template v-else-if="header.fieldName === 'processUuid'">
            {{ link[header.fieldName]?link[header.fieldName]:'—' }}
          </template>
          <template v-else-if="header.fieldName === 'fileCount'">
            {{ link[header.fieldName]?link[header.fieldName]:'—' }}
          </template>
          <template v-else-if="header.fieldName === 'newFileCount'">
            {{ link[header.fieldName]?link[header.fieldName]:'—' }}
          </template>
          <template v-else-if="header.fieldName === 'executionsCount'">
            <template v-if="link.s3FilePath">
              <button
                type="button"
                class="links-table__executions-button"
                aria-label="Open document report"
                @click="handleExecutionsCountClick(link)"
              >
                {{ link[header.fieldName] }}
              </button>
            </template>
            <template v-else>
              <span>{{ link[header.fieldName] }}</span>
            </template>
          </template>
          <template v-else-if="header.fieldName === 'errorMessage'">
              <template v-if="link[header.fieldName]">
                <mds-button
                  :id="`prompt-trigger-error${index}`"
                  variation="icon-only"
                  icon="open-new"
                  type="button"
                  text="Copy"
                  @click="copyErrorToClipboard(index, link[header.fieldName])"
                />
                <mds-tooltip
                  v-model="copiedError[index]"
                  :triggered-by="`prompt-trigger-error${index}`"
                  :position="['right-center']"
                  class="crawled-documents__tooltip"
                >
                  {{ $t(`collectionPrEcPage.copied`) }}
                </mds-tooltip>
              </template>
            </template>
          <template v-else-if="header.fieldName === 'link'">
            <a
              target="_blank"
              :href="link.link"
              v-text="link.link"
            />
          </template>
          <template v-else-if="header.fieldName === 'status'">
            <status-tag :status="link[header.fieldName]" />
          </template>
          <template v-else-if="header.fieldName === 'actions'">
            <mds-button-container>
              <router-link
                :to="{
                  name: $options.route.SNAPSHOT_JOB,
                  params: { prEcJobId: link.prEcJobId },
                  query: { 'index-type': link.indexType }
                }"
              >
                <mds-button
                  variation="icon-only"
                  icon="eye"
                  type="button"
                />
              </router-link>
            </mds-button-container>
          </template>
          <template v-else>
            {{ '—' }}
          </template>
        </mds-td>
      </mds-tr>
    </mds-tbody>
  </mds-table>
</template>

<script>
import { MdsTable, MdsTbody, MdsTr, MdsTd } from '@mds/data-table';
import { MdsButton, MdsButtonContainer } from '@mds/button';
import { PROVIDER_EXECUTIONS_HEADERS } from '@/constants/pr-ec.constant';
import StatusTag from '@/components/ui/StatusTag';
import { formatDate } from '@/utils/global.util';
import ROUTE from '@/constants/routes.constant';
import LinkActions from '@/components/collection/table/actions/LinkActions';
import MdsTooltip from '@mds/tooltip';
import { getPrEcDocumentReport } from '@/services/api/pr-ec.service';

export default {
  name: 'LinksTable',
  components: {
    StatusTag,
    MdsTable,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsButton,
    MdsButtonContainer,
    LinkActions,
    MdsTooltip
  },
  filters: {
    formatDate,
    formatIndexType (index) {
      return index && index.split('_')[1];
    },
    sumProviderLinksErrors (link) {
      return link.filesFoundCount === 0 ? 0 : link.filesFoundCount - link.downloadedFilesCount;
    },
  },
  data() {
    return {
      copied: {},
      copiedError: {},
    };
  },
  props: {
    links: {
      type: Array,
      required: true,
    },
  },
  headers: PROVIDER_EXECUTIONS_HEADERS,
  route: ROUTE,
  methods: {
    copyErrorToClipboard(index, errorMessage) {
      navigator.clipboard.writeText(errorMessage).then(() => {
        this.$set(this.copiedError, index, true);
        setTimeout(() => {
          this.$set(this.copiedError, index, false);
        }, 2000);
      });
    },
    async handleExecutionsCountClick(link) {
      if (!link || !link.s3FilePath) {
        return;
      }

      try {
        const { data } = await getPrEcDocumentReport(link.s3FilePath);
        const blob = new Blob([data], { type: 'application/pdf' });
        const fileUrl = window.URL.createObjectURL(blob);
        // Open the generated PDF blob in a new tab and revoke the URL after use
        window.open(fileUrl, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(fileUrl), 10000);
      } catch (error) {
        console.error('Failed to open document report', error);
      }
    },
  },
};
</script>

<style scoped>
.links-table__executions-button {
  background: none;
  border: none;
  padding: 0;
  color: #005ea5;
  cursor: pointer;
  text-decoration: underline;
  font: inherit;
}

.links-table__executions-button:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

.links-table__executions-button:disabled {
  color: #9da0a4;
  cursor: not-allowed;
  text-decoration: none;
}
</style>
